import _toConsumableArray from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _classCallCheck from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/createClass.js";
var H = /*#__PURE__*/function () {
  function H() {
    var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
    var s = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    _classCallCheck(this, H);
    this.W = t, this.ue = s, this.W = t, this.ue = s;
  }
  _createClass(H, [{
    key: "Vt",
    value: function Vt(t) {
      var _this$ue;
      this.W = this.W && t.W, (_this$ue = this.ue).push.apply(_this$ue, _toConsumableArray(t.ue));
    }
  }]);
  return H;
}();
export { H as default };